var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M9 11h10a1 1 0 0 1 0 2H9v3l-5-4 5-4zm3-4a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm0 12a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2z"
})));
export default SvgNavClose;